import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/signin/signin.component';
// import { SignupComponent } from './components/signup/signup.component';
import { HomeComponent } from './components/home/home.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { ProductComponent } from './components/product/product.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { MyCartComponent } from './components/my-cart/my-cart.component';
import { PaymentOptionComponent } from './components/payment-option/payment-option.component';
import { OrderSumamaryComponent } from './components/order-sumamary/order-sumamary.component';
import { SellerProductPageComponent } from './components/seller-product-page/seller-product-page.component';
import { SellerProductAllProductComponent } from './components/seller-product-all-product/seller-product-all-product.component';

import { StpesComponent } from './components/stpes/stpes.component';
import { PrefixNot } from '@angular/compiler';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
import { RatingComponent } from './components/rating/rating.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { MyorderListComponent } from './components/myorder-list/myorder-list.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { OrderCancelledComponent } from './components/order-cancelled/order-cancelled.component';
import { MyOrderCancelModelComponent } from './components/my-order-cancel-model/my-order-cancel-model.component';
import { OrderReturnComponent } from './components/order-return/order-return.component';
import { ExchangeOrderComponent } from './components/exchange-order/exchange-order.component';
import { HelpSupportComponent } from './components/help-support/help-support.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { DirectPurchaseComponent } from './components/direct-purchase/direct-purchase.component';
import { PaymentFailComponent } from './components/payment-fail/payment-fail.component';
import { TicketRaisedChatComponent } from './components/ticket-raised-chat/ticket-raised-chat.component';
import { OrderTrackComponent } from './components/order-track/order-track.component';
import { CustomerFeedbackPageComponent } from './components/customer-feedback-page/customer-feedback-page.component';
import { AskQuestionComponent } from './components/ask-question/ask-question.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { FaqComponent } from './components/faq/faq.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '' },
  { path: '', component: HomeComponent },
  { path: 'forget-Password', component: ForgetPasswordComponent },
  { path: 'reset-password/:token', component: ForgetPasswordComponent },
  { path: 'product-list', component: ProductListComponent },
  { path: 'product-list/:id', component: ProductListComponent },
 
  { path: 'my-cart', component: MyCartComponent },
  { path: 'payment-option', component: PaymentOptionComponent },
  { path: 'order-sumamary', component: OrderSumamaryComponent },
  { path: 'order-sumamary/:id', component: OrderSumamaryComponent },
  { path: 'seller-product-page', component: SellerProductPageComponent },
  { path: 'seller-product-page/:id', component: SellerProductPageComponent },
  { path: 'seller-all-products', component: SellerProductAllProductComponent },
  { path: 'wallet', component: WalletComponent },

  {
    path: 'seller-all-products/:id',
    component: SellerProductAllProductComponent,
  },
  { path: 'steps', component: StpesComponent },
  { path: 'steps/:id', component: StpesComponent },
  { path: 'profile-details', component: ProfileDetailsComponent, canActivate: [AuthGuard] },
  { path: 'add-address', component: AddAddressComponent },
  { path: 'otp-verification', component: OtpVerificationComponent },
  { path: 'Rating', component: RatingComponent },
  { path: 'Rating/:id', component: RatingComponent },
  { path: 'add-Address', component: AddAddressComponent },
  { path: 'add-Address/:id', component: AddAddressComponent },
  { path: 'Signin/:id', component: SigninComponent },
  { path: 'Signin', component: SigninComponent },
  { path: 'termsCondition', component: TermsConditionsComponent },
  { path: 'policyPrivacy', component: PrivacyPolicyComponent },
  { path: 'profile-details/:id', component: ProfileDetailsComponent, canActivate: [AuthGuard] },
  { path: 'order-details/:id', component: OrderDetailsComponent },
  { path: 'order-cancelled', component: OrderCancelledComponent },
  { path: 'order-cancelled/:id', component: OrderCancelledComponent },
  { path: 'my-order-cancel-model/:id', component: MyOrderCancelModelComponent },
  { path: 'my-order-cancel-model', component: MyOrderCancelModelComponent },
  { path: 'returnOrder', component: OrderReturnComponent },
  { path: 'returnOrder/:id', component: OrderReturnComponent },
  { path: 'exchange-order', component: ExchangeOrderComponent },
  { path: 'help-support', component: HelpSupportComponent },
  { path: 'sellerAllProduct', component: SellerProductAllProductComponent },
  { path: 'product-list/:categoryId', component: ProductListComponent },
  { path: 'direct-purchase', component: DirectPurchaseComponent },
  { path: 'payment-fail', component: PaymentFailComponent },
  // { path: 'ticket-raise-chat/:ticketId', component: TicketRaisedChatComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'ticket-raised-chat', component: TicketRaisedChatComponent },
{ path: 'track-order', component: OrderTrackComponent },
  // ... other routes
  { path: 'track-order/:id', component: OrderTrackComponent }, // Use `:id` or `:waybill`
// { path: 'track-order/:orderId', component: OrderTrackComponent },
{ path: 'customer-comment/:id', component: CustomerFeedbackPageComponent },

  // { path: '', redirectTo: '/signin', pathMatch: 'full' },
  {
    path: 'product-details',
    loadChildren: () =>
      import('./components/product-details/product-details.module').then(
        (m) => m.ProductDetailsModule
      ),
  },
  {
    path: ':idOrSlug',
    loadChildren: () =>
      import('./components/product-details/product-details.module').then(
        (m) => m.ProductDetailsModule
      ),
  },
  //for page not found
  { path: '**', component: PageNotFoundComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: 'ask-question', component: AskQuestionComponent },

  // 🚨 Wildcard (must be last)
  { path: '**', redirectTo: '', pathMatch: 'full' },
   
  // {path: 'Signup', component:SignupComponent },
  // { path: '', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
